"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenXmlRelation = void 0;
var string_1 = require("@devexpress/utils/lib/utils/string");
var OpenXmlRelation = (function () {
    function OpenXmlRelation(id, target, type, targetMode) {
        this.id = id;
        this.target = target;
        this.type = type;
        this.targetMode = targetMode;
    }
    OpenXmlRelation.prototype.isEmpty = function () {
        return string_1.StringUtils.isNullOrEmpty(this.id) ||
            string_1.StringUtils.isNullOrEmpty(this.type) ||
            string_1.StringUtils.isNullOrEmpty(this.target);
    };
    return OpenXmlRelation;
}());
exports.OpenXmlRelation = OpenXmlRelation;
